export const supplierConsult = {
  form: {
    supplier_name: "Nom du fournisseur",
    email: "Email Fournisseur",
    telephone: "Téléphone",
    address: "Adresse",
    documents: "Documents internes",
    collaborators: "Collaborateurs",
    add_collaborator: "Ajouter un Collaborateur",
    delete_success: "Utilisateur supprimé avec succès !",
    delete_error: "Erreur lors de la suppression !",
  },
};
